import React, { useState, useEffect, useCallback } from 'react';
import { authenticateAdmin } from './utils/auth';
import api from './utils/api';
import Sidebar from './components/Sidebar';
import BottomNav from './components/BottomNav';
import DashboardScreen from './components/DashboardScreen';
import OrdersScreen from './components/OrdersScreen';
import UsersScreen from './components/UsersScreen';
import ReferralsScreen from './components/ReferralsScreen';
import RatesScreen from './components/RatesScreen';
import EventsScreen from './components/EventsScreen';

export default function AdminApp() {
  const [authState, setAuthState] = useState('loading');
  const [authError, setAuthError] = useState('');
  const [adminUser, setAdminUser] = useState(null);
  const [currentScreen, setCurrentScreen] = useState('dashboard');

  useEffect(() => {
    const init = async () => {
      try {
        const result = await authenticateAdmin();
        api.setAuth(result.token, result.userId);
        setAdminUser(result.user);
        setAuthState('authenticated');
      } catch (error) {
        setAuthState('error');
        const messages = {
          NO_TELEGRAM: 'Откройте приложение через Telegram бота',
          NO_USER_DATA: 'Не удалось получить данные пользователя',
          AUTH_FAILED: 'Ошибка аутентификации',
          NOT_ADMIN: 'Доступ запрещён. У вас нет прав администратора.',
        };
        setAuthError(messages[error.message] || `Ошибка: ${error.message}`);
      }
    };
    init();
  }, []);

  const handleNavigate = useCallback((screen) => {
    setCurrentScreen(screen);
  }, []);

  if (authState === 'loading') {
    return (
      <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-900 to-black flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-purple-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-gray-400 text-sm">Проверка доступа...</p>
        </div>
      </div>
    );
  }

  if (authState === 'error') {
    return (
      <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-900 to-black flex items-center justify-center p-4">
        <div className="bg-gray-800/50 rounded-2xl p-8 max-w-sm w-full text-center border border-gray-700/50">
          <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">🔒</span>
          </div>
          <h2 className="text-xl font-bold text-white mb-2">Доступ запрещён</h2>
          <p className="text-gray-400 text-sm">{authError}</p>
        </div>
      </div>
    );
  }

  const screens = {
    dashboard: <DashboardScreen />,
    orders: <OrdersScreen />,
    users: <UsersScreen />,
    referrals: <ReferralsScreen />,
    rates: <RatesScreen />,
    events: <EventsScreen />,
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-900 to-black font-sans">
      <div className="hidden md:block">
        <Sidebar
          currentScreen={currentScreen}
          onNavigate={handleNavigate}
          adminUser={adminUser}
          isOpen={true}
          onToggle={() => {}}
        />
        <main className="ml-64 p-6">
          {screens[currentScreen] || <DashboardScreen />}
        </main>
      </div>

      <div className="md:hidden">
        <main className="pb-32 px-4 pt-24">
          {screens[currentScreen] || <DashboardScreen />}
        </main>
        <BottomNav currentScreen={currentScreen} onNavigate={handleNavigate} />
      </div>
    </div>
  );
}
